import { render, staticRenderFns } from "./AccountsCreateForm.vue?vue&type=template&id=46b887e4&"
import script from "./AccountsCreateForm.vue?vue&type=script&lang=js&"
export * from "./AccountsCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports